import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styles from './PoliticalOrientationChart.module.css';

const COLORS = ['#00d9ff', '#7c3aed', '#ec4899', '#f59e0b', '#10b981', '#ef4444', '#94a3b8'];

export default function PoliticalOrientationChart({ data }) {
    if (!data || data.length === 0) {
        return <div className={styles.empty}>لا توجد بيانات للتوجهات السياسية</div>;
    }

    const nonZero = data.filter((d) => d.value > 0);

    return (
        <div className={styles.wrap}>
            <div className={styles.chart}>
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={nonZero}
                            cx="50%"
                            cy="50%"
                            outerRadius={110}
                            dataKey="value"
                            label={({ name, percentage }) => percentage > 2 ? `${percentage}%` : ''}
                            labelLine={false}
                        >
                            {nonZero.map((_, i) => (
                                <Cell key={i} fill={COLORS[i % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(v, n) => [`${v} احتجاج`, n]}
                            contentStyle={{ background: '#1e2a3a', border: '1px solid #334155', borderRadius: 8 }}
                            itemStyle={{ color: '#e2e8f0' }}
                        />
                        <Legend
                            iconType="circle"
                            iconSize={10}
                            formatter={(value) => <span style={{ color: 'var(--text-primary)', fontSize: 13 }}>{value}</span>}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.th}>التوجه</th>
                        <th className={styles.th}>العدد</th>
                        <th className={styles.th}>النسبة</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr key={i} className={styles.tr}>
                            <td className={styles.td}>
                                <span className={styles.dot} style={{ background: COLORS[i % COLORS.length] }} />
                                {item.name}
                            </td>
                            <td className={styles.td}>{item.value?.toLocaleString('ar-SY')}</td>
                            <td className={styles.td}>{item.percentage}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
